import { api } from '@/lib/api'
import type {
  LoginRequest,
  LoginResponse,
  TOTPVerifyRequest,
  TokenResponse,
  UserResponse,
} from '@/types/auth'

export async function loginRequest(body: LoginRequest): Promise<LoginResponse> {
  const { data } = await api.post<LoginResponse>('/auth/login', body)
  return data
}

export async function verifyRequest(body: TOTPVerifyRequest): Promise<TokenResponse> {
  const { data } = await api.post<TokenResponse>('/auth/verify', body)
  return data
}

export async function fetchMe(): Promise<UserResponse> {
  const { data } = await api.get<UserResponse>('/auth/me')
  return data
}
